import { RedoOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Select, Skeleton, Tooltip } from "antd";
import React, { FC, useEffect, useRef, useState } from "react";
import AppScreen from "screens/teacher/ScreenWithSidebar";

//!COMPONENTS
import Breadcrumbs from "components/breadcrumbs";
import CardQuiz from "../components/cardQuiz";
import HeaderComponents from "../components/headerComponents";

//!STYLES
import s from "./assets/easyQuiz.module.css";

import { findFilterQuizOfCoursesStudent } from "api/services/studentQuizz/studentQuizz.services";
import { PlayLevel, StatusCode } from "common/enums";
import AppResult from "components/appResults";
import AppButton from "components/libs/button";
import useGetQuiz from "hooks/useGetQuizz";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setIsBotCalled } from "store/app/appSlice";
import TabsStudent from "../components/tabs";

const EasyQuiz: FC = () => {
  const { idCours } = useSelector((state: any) => state.courses);
  const { id, level } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, data, setData, setLoading } = useGetQuiz(id!, level!);
  // const { quizForCours, isloading, error } = useQuizzForCours(idCours);

  const isFirstRender = useRef(true);

  const [form] = Form.useForm();

  const refSubmited = useRef<any>();

  const { isLoggedIn, user } = useSelector((state) => state.auth);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const [quizLevel, setQuizLevel] = useState<string>("");
  const [quizDuration, setQuizDuration] = useState<string>("");

  const { Option } = Select;

  const filterQuiz = async () => {
    setLoading(true);
    if (quizDuration) {
      try {
        const response = await findFilterQuizOfCoursesStudent(
          id!,
          quizLevel,
          quizDuration.split(".")[0],
          quizDuration.split(".")[1]
        );

        if (response?.statusCode === StatusCode.OK) {
          setData(response?.data);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
    else {
      try {
        const response = await findFilterQuizOfCoursesStudent(
          id!,
          quizLevel,
          "",
          ""
        );

        if (response?.statusCode === StatusCode.OK) {
          setData(response?.data);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
  };

  const handleClick = () => {
    dispatch(setIsBotCalled(true));
  }

  const onReset = () => {
    form.resetFields(['quizzLevel', 'duration']);
    setQuizLevel("");
    setQuizDuration("");
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    filterQuiz();
  }, [quizLevel, quizDuration]);

  return (
    <React.Fragment>
      {isMobile && isLoggedIn && <div style={{ height: user?.accountManaged !== null ? "0px" : "0px", width: "100%" }}></div>}
      {!isMobile && <Breadcrumbs isMycontent={true} />}
      {/* <PageHeaderBack title={data[0]?.course?.title} /> */}
      <AppScreen className={s.easyQuiz}>
        <HeaderComponents />

        <TabsStudent
          level={level}
          onRequest={() => { }}
          onExit={() => { }}
          textBack="Retour aux chapitres"
        />

        <div className={s.header}>
          <div className={s.left}>
            <span style={{ color: "var(--first-color)" }}>
              {data.length} Quiz trouvé(s) - {level}
            </span>
          </div>

          <div>
            <Form
              name="basic"
              autoComplete="off"
              form={form}
            /* onFieldsChange={filterQuiz} */
            >
              <Row gutter={18}>
                <div className={`${s.select}`}>
                  <Form.Item name="quizzLevel">
                    <Select placeholder="Niveau quiz" bordered={false} onChange={(value: any) => setQuizLevel(value)}>
                      <Option value={PlayLevel.EASY}>{PlayLevel.EASY}</Option>
                      <Option value={PlayLevel.MEDIUM}>
                        {PlayLevel.MEDIUM}
                      </Option>
                      <Option value={PlayLevel.HARD}>{PlayLevel.HARD}</Option>
                      <Option value="">Tous les quiz</Option>
                    </Select>
                  </Form.Item>
                </div>

                <Col>
                  <div className={`${s.select}`}>
                    <Form.Item name="duration">
                      <Select placeholder="Durée" bordered={false} onChange={(value: any) => setQuizDuration(value)}>
                        <Option value={"5.10"}>5 - 10 min</Option>
                        <Option value={"10.20"}>10 - 20 min</Option>
                        <Option value={"20.30"}>20 - 30 min</Option>
                        <Option value={"30.60"}>Plus de 30 min</Option>
                      </Select>
                    </Form.Item>
                  </div>
                </Col>
              </Row>

              <Tooltip placement="left" title={"Réinitialiser tous les filtres"}>
                <Button
                  className={s.__reset__btn}
                  onClick={onReset}
                  shape="circle"
                  htmlType="button"
                >
                  <RedoOutlined />
                </Button>
              </Tooltip>
            </Form>
          </div>
        </div>

        <div className="main">
          {loading && (
            <div>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>
          )}

          {!loading && (
            <div className={s.cardDisplay}>
              {data?.result?.map((quiz: any, i: number) => (
                <div key={i}>
                  <CardQuiz quiz={quiz} />
                </div>
              ))}
            </div>
          )}

          {!loading && data.result.length <= 0 && (
            <AppResult status="info" title={
              <>
                Oups, aucun quiz n’est disponible pour cette durée. <br />
                Mais tu peux toujours demander à Albert de t’en créer un.
              </>
            } />
          )}

          {!loading && data.result.length <= 0 && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "120px" }}>
            <AppButton onClick={handleClick}>
              Démarrer le chat
            </AppButton>
          </div>}
        </div>
      </AppScreen>
    </React.Fragment>
  );
};

export default EasyQuiz;
